module.exports = __webpack_public_path__ + "img/feature-image.0d2e00ee.jpg";